var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CLIENT_VAL_OTP, CLIENT_VAL_OTP_ERROR, CLIENT_VAL_OTP_HIDE_ERROR, CLIENT_VAL_OTP_START_LOADER, CLIENT_VAL_OTP_STOP_LOADER, LOGIN_SHOW_POPUP, } from "../interface/IClientValOTP";
var initState = {
    data: {
        jwtToken: "",
        cnsntLst: [],
        accData: {
            accTyp: "",
            accs: {
                bseMfstwt: false,
                cdslAuToSl: false,
                cdslEsFlg: false,
                emailCnsnt: false,
                eml: "",
                eqAccID: "",
                eqAccName: "",
                eqAlgoClnt: "",
                eqBrId: "",
                eqBrk: "",
                eqBrkCode: "",
                eqDob: "",
                eqEmpCat: "",
                eqRmRt: "",
                eqstwt: false,
                llt: "",
                mfInf: false,
                mobCnsnt: false,
                prfId: "",
                rstpwd: false,
                rstusr: false,
                ucmCd: "",
                uid: "",
                wtspCnsnt: "",
                empOrDependent: "",
                productsAlias: [],
            },
            typ: "",
            srcVendor: "",
            url: "",
            logoLnk: "",
            userID: "",
            defaultPrds: {},
            excs: [],
            ordTypes: [],
            orderSlicingLimit: 0,
            dfPrdsMTF: null,
            prds: [],
            val: [],
            mrgAccDts: {
                emIds: [],
                phNos: [],
                uids: [],
            },
            othAccDts: {
                accTyp: "",
                isAct: false,
                isOnline: false,
                uid: "",
            },
            mrgSts: "",
            mtf: "",
            adhrEQ: { stat: "", brkCode: "" },
            adhrCOM: { stat: "", brkCode: "" },
            opCnst: [],
            coAccID: "",
            eqAccID: "",
            eqRmRt: "",
            prefAccTyp: null,
            eqAccName: "",
            coAccName: "",
            prfId: "",
            wtspCnsnt: null,
            productsAlias: [],
            dfPrds: {},
            panAadhaarLinked: false,
            kraRegComplete: false,
        },
        accTyp: "",
        userID: "",
        emaildId: "",
        accountCode: "",
        lgnSrc: "",
        isImpersonated: false,
        userName: "",
        empOrDependent: "",
        productsAlias: [],
    },
    loader: false,
    showLoginPopup: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
var ClientValOTP = function (state, action) {
    var _a;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case CLIENT_VAL_OTP:
            return __assign(__assign({}, state), { data: action.payload.data });
        case CLIENT_VAL_OTP_ERROR:
            return __assign(__assign({}, state), { errorData: action.payload.errorData });
        case CLIENT_VAL_OTP_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: initState.errorData });
        case CLIENT_VAL_OTP_START_LOADER:
            return __assign(__assign({}, state), { loader: true });
        case LOGIN_SHOW_POPUP:
            return __assign(__assign({}, state), { showLoginPopup: (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.showLoginPopup });
        case CLIENT_VAL_OTP_STOP_LOADER:
            return __assign(__assign({}, state), { loader: false });
        default:
            return __assign({}, state);
    }
};
export default ClientValOTP;
